module.exports = __webpack_public_path__ + "img/score_0.fcf6dc94.png";